import * as React from 'react';
import ArrowDownOutlined from './arrow-down-outlined';
import ArrowDownFilled from './arrow-down-filled';
import type { IconCombinedProps } from './types';
const ArrowDownCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ArrowDownFilled ref={ref} {...rest} />;
  }
  return <ArrowDownOutlined ref={ref} {...rest} />;
});
export default ArrowDownCombined;